import type { ReportJobStatuses } from '@weft/types';
import { REPORT_JOB_STATUSES, type ReportData } from '@weft/types';
import { filterBy, isNullOrUndefined, withDefault } from '@weft/utils';
import { sortBy, values } from 'lodash';
import { getReportJobType } from '../../pages/reports/reports-page/reports-page-components/ReportsPageContent';
import type { ReportType } from '../../pages/reports/reports-page/reports-page-types/report-type';
import { REPORT_TYPES } from '../../pages/reports/reports-page/reports-page-types/report-type';
import { useReports } from './use-reports';

export function useAllReports() {
  const { data: reportsData } = useReports({ suspense: true });
  const { ALL_REPORTS, ...REST_OF_REPORTS } = REPORT_TYPES;
  
  return values(REST_OF_REPORTS).map((reportType: ReportType)=> getLatestReport(reportType, reportsData));
}

function getLatestReport(reportType: ReportType, reportsData: ReportData[]) {
  const reportJobType = getReportJobType(reportType);
  
  if (isNullOrUndefined(reportJobType)) {
    return buildReport(reportType);
  }

  const filteredReports = filterBy(reportsData, reportJobType, 'type');
  const latestReport = sortBy(filteredReports, 'createdAt')[filteredReports.length - 1];
  
  return buildReport(reportType, latestReport);
}

export type summaryReport = {
  reportName: string;
  status: ReportJobStatuses;
  type: Omit<ReportType, typeof REPORT_TYPES.ALL_REPORTS>;
  id?: string;
};

function buildReport(type: ReportType, report?: ReportData): summaryReport {
  return {
    reportName: withDefault(report?.reportName, '--'),
    status: withDefault(report?.status, REPORT_JOB_STATUSES.Completed),
    type,
    id: report?.id,
  };
}